import { useState, ReactNode, SyntheticEvent, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useMyStore } from "src/components/main/mainStore";
import { ReactComponent as Minimize }  from "src/img/svg/minimize.svg";
import { ReactComponent as Maximize }  from "src/img/svg/maximize.svg";
//--------------------------------------------------------------------------------------------
export default function Modal({
    title, 
    closeIt, 

    handleFormSubmit, 
    actionKey, 
    onSave, 
    onSaveTitle, 
    titleBgColor, 
    titleColor,
    children, 
    touchOutsideClose, 
    formFormat, 
    max, 
    noTopCloseIt, 
    width, 
    minWidth, 
    maxWidth, 
    show
}:{
    title: string,
    closeIt: Function, 
    
    handleFormSubmit?: Function, 
    actionKey?: string, 
    onSave?: Function, 
    onSaveTitle?: string, 
    titleBgColor?: string, 
    titleColor?: string,
    children?: ReactNode, 
    touchOutsideClose?: boolean, 
    formFormat?: string, 
    max?: boolean, 
    noTopCloseIt?: boolean, 
    width?: number | string, 
    minWidth?: number | string, 
    maxWidth?: number | string, 
    show?: string
}){
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const [curMax, setMax] = useState(max || false);
    //--------------------------------------------------------------------------------------------
    const lastFocusedElementRef = useRef<HTMLButtonElement | null>(null);
    const modalRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        lastFocusedElementRef.current = (document.activeElement as HTMLButtonElement);
        (modalRef.current as HTMLDivElement)!.focus();
        return () => {
            lastFocusedElementRef.current!.focus();
        }
      }, []);
    return createPortal(    
        <div
            className = "myModal"
            onClick = {e => {
                if(e.target === e.currentTarget && touchOutsideClose){
                    closeIt();
                }
            }}
            style = {{
                display: show || undefined, 
                zIndex: show === "" ? 99 : undefined
            }}
        >
            <div
                className = "modalContent" 
                style = {{
                    width: curMax ? "100%" : width ?? "90rem",
                    minWidth: minWidth ?? "18rem", 
                    maxWidth: curMax || !maxWidth ? "100%" : maxWidth, 
                    marginTop: curMax ? "0%" : "3rem"
                }}
            >
                <div
                    className = "modalHeader"
                    style = {{
                        backgroundColor: titleBgColor || user.userTheme, 
                        color: titleColor || "white",
                    }}
                >
                    <button
                        className = "pointer bg-inherit"
                        onClick = {() => {
                            setMax(m => !m);
                        }}
                    >
                        {curMax?
                        <span>
                            <Minimize/>
                        </span>:
                        <span>
                            <Maximize/>
                        </span>}
                    </button>
                    <span className = "ml-2 mr-auto">
                        {title}
                    </span>
                    {noTopCloseIt?
                    <></>:
                    <button
                        className = "modalX"
                        onClick = {() => closeIt()}
                    >
                        &times;
                    </button>
                    }
                </div>
                <form
                    className = {formFormat ?? "form-inline"}
                    onSubmit = {e => {
                        e.preventDefault();
                        handleFormSubmit?.(e);
                    }}
                >
                    <div
                        tabIndex = {-1}
                        ref = {modalRef}
                        className = "container-fluid position-relative"
                    >
                        {children}
                    </div>
                    <div
                        className = "modal-footer w-100"
                    >
                        {false?
                        <button
                            type = "reset"
                            className = "btn btn-danger"
                        >
                            Reset
                        </button>
                        :<></>}
                        {actionKey?
                        <button
                            type = "submit"
                            value = "Submit"
                            className = "btn btn-primary"
                        >
                            {actionKey}
                        </button>:<></>}
                        {onSave?
                        <button
                            className = "btn btn-success"
                            type = "button" // "submit"
                            // value = "Submit"
                            // formNoValidate = {true}
                            onClick = {(e: SyntheticEvent) => {
                                const form = e.currentTarget.parentNode?.parentNode;
                                //form.noValidate = true; 
                                onSave(form);
                                //form.noValidate = false;
                            }}
                        >
                            {onSaveTitle || "Save"}
                        </button>
                        :<></>}
                        <button
                            type = "button"
                            className = "btn btn-dark"
                            onClick = {() => closeIt()}
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    , document.getElementById("app-root")!
    );
}